import { type FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ControlledInput } from 'src/components/form/controlled-input/ControlledInput';
import { ControlledJsonEditor } from 'src/components/form/controlled-json-editor/ControlledJsonEditor';

export const IngestionConfigSettings: FC = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common', { keyPrefix: 'modules.fields' });

  return (
    <div className={'flex flex-col gap-4'}>
      <ControlledInput
        type={'password'}
        control={control}
        name={'IngestionApiKey'}
        label={t('IngestionApiKey')}
      />
      <ControlledJsonEditor
        control={control}
        name={'IngestionConfig'}
        label={t('IngestionConfig')}
      />
    </div>
  );
};
